import type { AxiosInstance } from 'axios'
import type { Workspace } from '@/types'

import BaseService from './BaseService'

export default class WorkspaceService extends BaseService<Workspace> {
  constructor(client: AxiosInstance) {
    super(client, 'workspace')
  }
}
